import { render, staticRenderFns } from "./ManageTea.vue?vue&type=template&id=7a5aa242"
import script from "./ManageTea.vue?vue&type=script&lang=js"
export * from "./ManageTea.vue?vue&type=script&lang=js"
import style0 from "./ManageTea.vue?vue&type=style&index=0&id=7a5aa242&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports